import { render, staticRenderFns } from "./dyd.vue?vue&type=template&id=3874d540&scoped=true&"
import script from "./dyd.vue?vue&type=script&lang=js&"
export * from "./dyd.vue?vue&type=script&lang=js&"
import style0 from "./dyd.vue?vue&type=style&index=0&id=3874d540&lang=less&scoped=true&"
import style1 from "./dyd.vue?vue&type=style&index=1&id=3874d540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874d540",
  null
  
)

export default component.exports